export default __webpack_public_path__ + "static/media/calendar.8248040c.svg";